import { useState, useEffect, useCallback } from "react";
import { Redirect } from 'react-router-dom'
import { useHistory, Link } from "react-router-dom";
import notesHelper from '../helper/notesHelper'
import errorHandlerHelper from "../helper/errorHandlerHelper";

const CreateNote = (props) => {
    const history = useHistory();
    const [note, setNote] = useState('')
    const [textareaCSS, settextareaCSS] = useState('control')
    const [buttonLoading, setButtonLoading] = useState('button is-primary')
    const getNote = useCallback(async () => {
        try {
            settextareaCSS('control is-loading')
            setButtonLoading('button is-primary is-loading')
            const { response, data } = await notesHelper.getSpecificNote(props.token, props.id)
            settextareaCSS('control')
            setButtonLoading('button is-primary')
            if (response.ok) {
                setNote(data.content)
            }
            else {
                errorHandlerHelper.errorHandler(response, data, props.logout, history, props.showToast)
            }
        }
        catch (err) {
            //hanlde error
            console.error(err)
        }
    }, [history, props.id, props.logout, props.showToast, props.token])

    //check if props.id changed then re render accordingly
    useEffect(() => {
        if (props.id) {
            getNote()
            return
        }
        else {
            setNote('')
        }
    }, [getNote, props.id])

    const createNote = async () => {
        if (!note) {
            props.showToast('error', 'Please enter some content to save!')
            return
        }
        settextareaCSS('control is-loading')
        setButtonLoading('button is-primary is-loading')
        const { response, data } = await notesHelper.createNote(note, props.token)
        settextareaCSS('control')
        setButtonLoading('button is-primary')
        if (response.ok) {
            props.showToast('success', 'Successfully Inserted Diary Note')
            history.push("/notes")

        }
        else {
            errorHandlerHelper.errorHandler(response, data, props.logout, history, props.showToast)
        }
    }
    const editNote = async () => {
        if (!note) {
            props.showToast('error', 'Please enter some content to edit!')
            return
        }
        settextareaCSS('control is-loading')
        setButtonLoading('button is-primary is-loading')
        const { response, data } = await notesHelper.editNote(note, props.token, props.id)
        settextareaCSS('control')
        setButtonLoading('button is-primary')
        if (response.ok) {
            props.showToast('success', 'Successfully Updated Diary Note')
            history.push("/notes")
        }
        else {
            //handle error
            errorHandlerHelper.errorHandler(response, data, props.logout, history, props.showToast)
        }
    }
    const renderButton = () => {
        if (props.isEditMode && !props.isCreateMode) {
            return <button className={buttonLoading} onClick={editNote}>
                <span class="icon is-small">
                    <i class="fas fa-save"></i>
                </span>
                <span>Save</span>
            </button>
        }
        if (props.isEditMode && props.isCreateMode) {
            return <button className={buttonLoading} onClick={createNote}>
                <span class="icon is-small">
                    <i class="fas fa-save"></i>
                </span>
                <span>Create</span>
            </button>
        }
        if (!props.isEditMode) {
            return <></>
        }
    }
    if (!props.isLoggedIn) {
        return <Redirect to='/login'></Redirect>
    }
    else {
        return (
            <div className="box is-centered">
                <div className="container">
                    <div className="field">
                        <div className={textareaCSS}>
                            <textarea style={{"height":"85vh"}} className="textarea" placeholder="Write the diary here ..." rows="15" onChange={(event) => { setNote(event.target.value) }} value={note} readOnly={!props.isEditMode}></textarea>
                        </div>
                    </div>
                    <div>
                        {renderButton()}
                        <Link className="button is-light ml-1" to="/notes">
                            <span class="icon is-small">
                                <i class="fas fa-angle-double-left"></i>
                            </span>
                            <span>Back</span>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }

}

export default CreateNote